export default __webpack_public_path__ + "static/media/mobile.ed896b2c.jpeg";